import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { addCustomRuleFormSchema } from './add-custom-rule-form.schema';

export const useAddCustomRuleForm = () => {
  const form = useForm({
    resolver: yupResolver(addCustomRuleFormSchema),
    defaultValues: addCustomRuleFormSchema.cast({}),
  });

  return { form };
};
